import { cn } from "@bem-react/classname";
import { getGroup, getJournal, selectTeacherJournal, setGroup} from "modules/TeacherJournal";
import { FC, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Journal.scss"
import "react-datepicker/dist/react-datepicker.css";
import { HeaderRow } from './HeaderRow'
import { FooterRow } from "./FooterRow";
import { UserRow } from "./UserRow";

const LeftPanel: FC = () => {
    const state = useSelector(selectTeacherJournal)
    const jcn = cn('Journal')
    const group = getGroup(state)
    const {users, tests, results} = getJournal(state, group)
    return         <div className={jcn("Container")}>
    <HeaderRow tests={tests}/>
    {users.map((user, index)=> <UserRow key={index} index={index} user={user} results={results.filter((i)=>i.user === user.id)} tests={tests}/>)}
    <FooterRow tests={tests} results={results} users={users}/>
</div>


}
const RightPanel: FC = () => {
    const state = useSelector(selectTeacherJournal)
    const jcn = cn('Journal')
    const group = getGroup(state)
    const {tests} = getJournal(state, group)
    return <div className={jcn('TestList')}><HeaderRow noplist={true} tests={tests}/></div>
}

const Spacer: FC = () => {
    const jcn = cn('Journal')
    const [moving, setMoving] = useState(false)
    const width = window.innerWidth
    const [position, setPosition] = useState(width<500?width-20:-1)
    const ref = useRef<HTMLDivElement|null>(null)
    const moveHdlr = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (moving){
            setPosition(ev.clientX - (ref.current?.parentElement as HTMLDivElement).offsetLeft - 5)
        }
    }
    useEffect(()=>{
        if (position === -1) {
            setPosition(ref.current!.offsetLeft - 5)
        }
        const par = ref.current?.parentElement as HTMLDivElement
        par.style.gridTemplateColumns = position + "px 3px"
    }, [position])
    const spantxt = position < width * 0.9?"»":"«"
    const spanClick = () => {
        if (position < width * 0.9){
            setPosition(width-20)
        } else {
            setPosition(0)
        }
    }
    return <><div ref={(el)=>ref.current = el}className={jcn('Spacer')} onMouseDown={(ev)=>{setMoving(true);}} onMouseUp={()=>setMoving(false)}>
        <div className={jcn('SpanBtn')} onClick={()=>spanClick()}>{spantxt}</div>
    </div>
    {moving?<div style={{position:"fixed", top: 0, bottom:0, left:0, right: 0, zIndex: 1}} onMouseMove={moveHdlr}  onMouseUp={()=>setMoving(false)}></div>:''}
    </>
}

const Info: FC = () => {
    const [isOpen, setOpen] = useState(false)
    const jcn = cn('Journal')
    return <>
        <div className={jcn('InfoBtn')} onClick={()=>setOpen(true)}>i</div>
        {isOpen?<div className={jcn('InfoDlg')}>
            <div className={jcn('InfoDlgClose')} onClick={()=>setOpen(false)}></div>
        Если кликнуть по <b>номеру работы</b>, то она откроется в новом окне.<br/>
        Если кликнуть по <b>названию работы</b>, увидите результаты каждого учащегося и средний балл за каждое задание. <br/>
        Если подвести мышку к <b>баллам учащегося</b>, увидите его баллы за каждое задание.<br/>
        Если кликнуть по <b>набранным баллам</b>, то в новом окне откроется статистика учащегося и окошко для комментария.<br/>
        Если кликнуть по <b>пустой клеточке</b>, то можно будет указать оценку вручную или поставить «н».
        </div>:''}
        </>
}

const Journal: FC = () => {
    const state = useSelector(selectTeacherJournal)
    const jcn = cn('Journal')
    const group = getGroup(state)
    const dispatch = useDispatch()
    if (!group){
        return <></>
    }
    if (!group?.loaded){
        return <>Идет загрузка…</>
    }
    let host = group.subject + '-' + group.portal+'.sdamgia.ru'
    if (group.portal === 'ct'){
        host = group.subject + '.reshu.by'
    }
    if (group.portal === 'olymp'){
        host = group.subject + '.reshuolymp.ru'
    }
    if (group.portal === 'zno'){
        host = group.subject + '.skladuzno.online'
    }
    if (group.portal === 'nmt'){
        host = group.subject + '.skladunmt.online'
    }
    if (group.portal === 'ent'){
        host = group.subject + '.reshuent.kz'
    }
    const baseUrl = 'https://' + host
    return <><div className={jcn('Overlay')}/><div className={jcn("Wrapper")}>
        
        <div className={jcn('TitleWrapper')}>
        
        <div className={jcn('FullscreenBtn')} onClick={()=>dispatch(setGroup())} >
            
            <svg height="100%" version="1.1" viewBox="0 0 24 24" width="100%">
                <defs>
                <path id="arr" d="M 2 2 l 6 2 l -2 1 l 4 4 l -1 1 l -4 -4 l -1 2 z"/>
                </defs>
                <use x='12' y='12' xlinkHref="#arr"/>
                <use transform="rotate(90, 12, 12)" x='12' y='12' xlinkHref="#arr"/>
                <use transform="rotate(180, 12, 12)" x='12' y='12' xlinkHref="#arr"/>
                <use transform="rotate(270, 12, 12)" x='12' y='12' xlinkHref="#arr"/>
            </svg>
        </div>
        <a className={jcn('ExcelIcon')} rel="noreferrer" href={baseUrl + '/teacher?a=get_stats&xlsx=1&ajax=1&group=' + group.id} target="_blank" title="Экспорт баллов в Excel"> </a>
        <a className={jcn('ExcelIcon') + ' Small'} rel="noreferrer" href={baseUrl + '/teacher?a=get_stats_short&xlsx=1&ajax=1&group=' + group.id} target="_blank" title="Экспорт оценок в Excel"> </a>
        <Info/>
        <span className={jcn('GroupName')}>{group.name}:</span></div>
        <LeftPanel/>
        <Spacer/>
        <RightPanel/>
        
    </div>
    </>
}

export default Journal